/**
 * Enum for different welcome message types in the signup flow
 */
export enum WelcomeMessageType {
  AIPlaylistGenerator = 'ai-playlist-generator',
  Download = 'download',
  PremiumDownload = 'premium-download',
}
